import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=0c756066&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=0c756066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c756066",
  null
  
)

export default component.exports